import { render, staticRenderFns } from "./AreaBusinessSign.vue?vue&type=template&id=596adc4c"
import script from "./AreaBusinessSign.vue?vue&type=script&lang=js"
export * from "./AreaBusinessSign.vue?vue&type=script&lang=js"
import style0 from "./AreaBusinessSign.vue?vue&type=style&index=0&id=596adc4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports